import { useMemo } from 'react'
import { ObjectiveRecord } from '@/api/models/objectiveRecord'

export function useIsMigratedCourse(objectiveRecords: ObjectiveRecord[]) {
  return useMemo(() => {
    return Boolean(objectiveRecords.length && objectiveRecords.every((or) => !or.objectiveWorkflowId))
  }, [objectiveRecords])
}
